module.exports = __webpack_public_path__ + "static/media/surfing_1600.9685abc5.webp";